import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-2xl font-heading font-bold text-primary-600">51</span>
            <span className="text-lg font-heading font-bold text-foreground-900">漫画网</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="px-4 py-2 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1">
                分类浏览
                <i className="ri-arrow-down-s-line text-sm"></i>
              </button>
              <div className="absolute top-full left-0 mt-1 bg-background-50 border border-background-200/70 rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 min-w-[160px]">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-3 px-4 py-3 text-sm text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer first:rounded-t-lg last:rounded-b-lg"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${cat.icon} text-primary-500`}></i>
                    </span>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className="px-4 py-3 text-sm font-medium rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              首页
            </Link>
            <div className="px-4 py-2 text-xs font-medium text-foreground-500">分类浏览</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-6 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-primary-500`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 text-sm font-medium rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}